import { OrganizationsModel } from "@purusha/purusha";

let savedOrganization = localStorage.getItem('selectedOrganization');

export const OrganizationsInitialState: OrganizationsModel = {
  list: [],
  domains: [],
  selected: savedOrganization ? JSON.parse(savedOrganization) : undefined
};
